import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import SubmissionDetails from '../../../SubmissionDetails';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export var DefaultDetails = function (_a) {
    var deviation = _a.deviation, className = _a.className, contentClassName = _a.contentClassName;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return (React.createElement("div", { className: classnames(s['root'], className, contentClassName) },
        React.createElement("div", { className: s['title-block'], "data-hook": BiDataHook.DEVIATION_META },
            React.createElement(SubmissionDetails, { deviation: deviation, showTitle: true })),
        isExtendedLoaded && React.createElement(ExtendedDetails, { deviation: deviation })));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
//# sourceMappingURL=Default.js.map